import * as React from 'react';
import * as TypeStyle from 'typestyle';
type NestedCSSProperties = TypeStyle.types.NestedCSSProperties;

/** @private */
export const FocusBlue = '#3498DB';
/** @private */
export const ErrorRed = '#C93A47';
/** @private */
export const ValidGreen = '#008057';

/** @private */
export const PreFocusIndicator = Object.freeze<React.CSSProperties>({
  borderColor: 'transparent',
  borderStyle: 'solid',
  borderWidth: 1,
});

const FocusIndicator = (color: string = FocusBlue) => Object.freeze<NestedCSSProperties>({
  borderColor: color,
  boxShadow: `0 0 4px 0 ${color}`,
  outline: 'none',
  $nest: {
    '&::-moz-focus-inner': { $unique: true, border: 'none' }
  }
});

/** @private */
export const DefaultFocusIndicator = FocusIndicator();
/** @private */
export const InvertFocusIndicator = FocusIndicator('white');
/** @private */
export const ErrorFocusIndicator = FocusIndicator(ErrorRed);
/** @private */
export const ValidFocusIndicator = FocusIndicator(ValidGreen);

/**
 * SVG doesn't support `box-shadow`; using pseudo element instead to get correct style
 * @private
 */
export const SVGInputFocusIndicatorBase: string = TypeStyle.style({
  position: 'relative',
  $nest: {
    '&.focus::after': {
      border: '1px solid transparent',
      ...DefaultFocusIndicator,
      content: `""`,
      position: 'absolute',
      pointerEvents: 'none',
      top: 1,
      right: 1,
      bottom: 1,
      left: 1,
    }
  }
});
